import { studentRequests } from "api/studentApi";
import { ChipField, ReferenceArrayField, SimpleShowLayout, SingleFieldList } from "react-admin";

export const FailedDisciplinesPanel = () => (
  <SimpleShowLayout>
    <ReferenceArrayField
      reference={studentRequests.getCurriculumDisciplinesSelect()}
      source="failedDisciplineIds"
      label={false}
    >
      <SingleFieldList linkType={false}>
        <ChipField source="name" />
      </SingleFieldList>
    </ReferenceArrayField>
  </SimpleShowLayout>
);
